import React from 'react'

export const linkifyUrls = (text) => {
  if (!text || typeof text !== 'string') return ''
  const tokenRegex =
    /\[([^\]]+)\]\(([^)]+)\)|<a\b[^>]*>(.*?)<\/a>|<(https?:\/\/[^>]+)>|(`[^`]+`)|((?:https?:\/\/|www\.)[^\s<>()"']+)/gi

  return text.replace(
    tokenRegex,
    (match, mdText, mdUrl, aContent, angleUrl, codeContent, rawUrl) => {
      if (mdText !== undefined && mdUrl !== undefined) return match
      if (aContent !== undefined) return match
      if (angleUrl !== undefined) return match
      if (codeContent !== undefined) return match
      if (rawUrl) {
        let cleanUrl = rawUrl
        let trailing = ''
        const m = rawUrl.match(/[.,;:!?*~_`"']+$/)
        if (m) {
          trailing = m[0]
          cleanUrl = rawUrl.slice(0, -trailing.length)
        }
        const href = cleanUrl.startsWith('http')
          ? cleanUrl
          : `https://${cleanUrl}`
        return `[${cleanUrl}](${href})${trailing}`
      }
      return match
    }
  )
}

export const formatAssistantMessage = (text) => {
  if (!text || typeof text !== 'string') return ''
  const withLinks = linkifyUrls(text.trim())
  return withLinks
    .replace(/(?<=[^\s*])(\*{1,2})(?=[A-Za-z0-9])/g, '$1 ')
    .replace(/(\d+\.\s)/g, '\n$1')
}

export const markdownComponents = {
  a: ({ node, href, children, ...props }) => {
    const formattedHref =
      href && href.startsWith('www.') ? `https://${href}` : href
    return (
      <a
        {...props}
        href={formattedHref}
        target='_blank'
        rel='noopener noreferrer'
        className='text-blue-600 dark:text-blue-400 font-semibold underline underline-offset-2 hover:text-blue-800 dark:hover:text-blue-300 break-all transition-colors cursor-pointer'
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </a>
    )
  },
}
